/**
 * The World Atlas line under the tracker's "where to go" maps (Tome UI Round 3, the next program's
 * E2). The cards above are local maps of one area each; this line is the world view, kept apart so
 * the two are not confused. It offers each map the guidance shows, in the same order (the objectives
 * while work is left, then the turn-in), where the atlas shows it; a quest only on drafts or pocket
 * maps says it is not on the atlas yet.
 */
import React from 'react';
import type { Quest } from '../../../shared/NPCData';
import { atlasPlace, useShowOnAtlas, type AtlasPlace } from '../Windows/WorldMap/atlasFocus';
import { COLORS, FONT_SIZE } from '../theme';

export function guidanceAtlasPlaces(quest: Quest): AtlasPlace[] {
  const guidance = quest.guidance;
  if (!guidance) return [];
  const workLeft = !quest.isTurnInReady && !quest.isCompleted;
  const maps = [
    ...(workLeft ? guidance.objectives.flatMap((o) => (o.location ? [o.location.mapId] : [])) : []),
    guidance.turnIn.location.mapId,
  ];
  return [...new Set(maps)].flatMap((id) => { const place = atlasPlace(id); return place ? [place] : []; });
}

export const QuestTrackerAtlasLinks: React.FC<{ quest: Quest }> = ({ quest }) => {
  const showOnAtlas = useShowOnAtlas();
  if (!quest.guidance) return null;
  const places = guidanceAtlasPlaces(quest);
  return <footer data-testid={`quest-tracker-atlas-${quest.id}`}
    style={{
      display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6, margin: '2px 0 0', padding: '8px 0 10px',
      borderTop: `1px solid ${COLORS.borderSubtle}`, fontSize: FONT_SIZE.sm,
    }}>
    <span className="npc-card-kicker" style={{ marginRight: 2 }}>On the World Atlas</span>
    {places.length === 0
      ? <em style={{ color: COLORS.textMuted }}>Not on the World Atlas yet</em>
      : places.map((p) => <button key={p.mapId} type="button" aria-label={`Show ${p.name} on the World Atlas`}
        data-testid={`quest-tracker-atlas-${quest.id}-${p.mapId}`} onClick={() => showOnAtlas(p.mapId)}
        style={{
          padding: '2px 8px', borderRadius: 6, cursor: 'pointer', font: 'inherit',
          border: `1px solid ${COLORS.borderSubtle}`, background: 'transparent', color: COLORS.brandAccent,
        }}>{p.name}</button>)}
  </footer>;
};
